@if (isCustomerView()) {
    <app-services-and-filings></app-services-and-filings>
} @else {
    <app-service-fulfillment></app-service-fulfillment>
}
